// extracted by mini-css-extract-plugin
module.exports = {"root":"AddButton_root__1uIHG","text":"AddButton_text__2aVrm","icon":"AddButton_icon__2jl11"};